import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from '../components/Layout'
import StudentListTabContent from '../components/teacher/StudentListTabContent'
import AdminStudentListWrapper from '../components/teacher/AdminStudentListWrapper'
import { AuthService } from '../services/auth'
import type { AuthUser } from '../services/auth'

const TeacherHomePage = () => {
  const [currentUser, setCurrentUser] = useState<AuthUser | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await AuthService.getCurrentUser()
        if (!user) {
          navigate('/?login=true')
          return
        }
        if (!['teacher', 'admin', 'super_admin'].includes(user.role)) {
          navigate('/videos')
          return
        }
        setCurrentUser(user)
      } catch {
        navigate('/?login=true')
      } finally {
        setIsLoading(false)
      }
    }
    checkAuth()
  }, [navigate])

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-8">
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#da4574]"></div>
          </div>
        ) : currentUser?.role === 'teacher' && currentUser.school_id ? (
          <StudentListTabContent schoolId={currentUser.school_id} />
        ) : currentUser?.role === 'admin' || currentUser?.role === 'super_admin' ? (
          <AdminStudentListWrapper />
        ) : null}
      </div>
    </Layout>
  )
}

export default TeacherHomePage
